import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ic_logout from "../assets/images/ic_logout.svg";
import wellbeinglogo from "../assets/images/PrivateStockIcon.png";

import { AppContext } from "../context/AppContext";

const Header = ({ setLoggedIn }) => {
  const { sidebar } = useContext(AppContext);
  const currentRoute = useLocation().pathname;

  const logout = (e) => {
    e.preventDefault();
    localStorage.clear();
    setLoggedIn(false);
  };

  return (
    <main className="cx-header">
      <div className={" cx-header-wrapper"}>
        <header>
          <div className="left">
            <Link to="/Dashboard">
              <img src={wellbeinglogo} alt="" />
              <span className="logo-text">Private Stock</span>
            </Link>
          </div>
          <div className="right">
            <Link to="#" className="bell me-2" onClick={logout}>
              <img src={ic_logout} className="ic-logout" alt="" />
            </Link>
          </div>
        </header>
      </div>
    </main>
  );
};

export default Header;
